<script lang="ts">

    import NauiCheckbox from "../naui/atoms/NauiCheckbox.svelte";
    import {Cart} from "../models/cart";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import LinearProgress from "@smui/linear-progress";

    export let adviser;
    export let enableAdviser: boolean = false;
    export let cart: Cart;
    export let loading: boolean;
    let dialog = {
        open: false,
        message: ''
    };

    async function genLink() {
        await update();
        const url = `${window.origin}/checkout/asesor?carrito=${cart.cartId}`;
        dialog.message = `Link para compartir el carrito de compras: <b>${url}</b>`;
        dialog.open = true;
    }

    async function update() {
        loading = true;
        cart.adviser = enableAdviser ? adviser : null;
        await cart.update();
        loading = false;
    }
</script>

<div class="bg-gray p-ii">
    {#if loading}
        <div class="container">
            <div class="text-c loading-bar">
                <LinearProgress class="w-100" indeterminate/>
                <small>Procesando...</small>
            </div>
        </div>
    {:else}
        <NauiCheckbox bind:value={enableAdviser} label="¿Eres asesor o te recomendo un asesor?"/>
        {#if enableAdviser}
            <div class="py-ii">
                <p>Ingresa los datos del asesor y genera el link para que tu cliente finalice la
                    orden</p>
                <div class="naui-field mb-1 mt-1">
                    <input type="email"
                           class="naui-input"
                           placeholder="Nombre asesor"
                           bind:value={adviser.name}>
                </div>
                <div class="naui-field mb-1">
                    <input type="email"
                           class="naui-input"
                           placeholder="Número de documento"
                           bind:value={adviser.doc}>
                </div>
                <div class="box">
                    <div class="btn accent" on:click={()=>genLink()}>Generar link</div>
                </div>
            </div>
        {/if}
    {/if}
</div>

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {@html dialog.message}
    </Content>
    <Actions>
        <div class="box sx-1 w-100">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={() => {dialog.open = false;}}/>
        </div>
    </Actions>
</Dialog>